import { render } from "./MyListSelectPage.vue?vue&type=template&id=5831b425&scoped=true&ts=true"
import script from "./MyListSelectPage.vue?vue&type=script&lang=ts"
export * from "./MyListSelectPage.vue?vue&type=script&lang=ts"

import "./MyListSelectPage.vue?vue&type=style&index=0&id=5831b425&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5831b425"]])

export default __exports__